import request from '../utils/request'

var Http = {};

Http.install = (Vue) => {
  let opt = {
    method: 'post',
    auth: true
  };
  Vue.prototype.$http = (opts) => {
    opts = Object.assign({}, opt, opts);
    return new Promise(function (resolve, reject) {
      request(opts).then(res => {
        if(opts.filter && typeof opts.filter === 'function') {
          // res.data.data => 真正的数据
          if(res.data.data) {
            res.data.data = opts.filter(res.data.data)
          }
        }
        if(res) resolve(res);
      }, res => {
        if(res) reject(res);
      });
    });
  }

  ['get', 'post', 'delete', 'put'].forEach(type => {
    Vue.prototype.$http[type] = (opts) => {
      opts.method = type;
      return Vue.prototype.$http(opts);
    }
  });
};

export default  Http;



// WEBPACK FOOTER //
// ./src/plugins/http.js